import { DataPage } from "@xbs/muon";
import { getCellIds, getCellInfo } from "./../helpers/main";
import { IAction, IActionConfig, SpreadsheetEvents } from "./../types";

export class RemoveCellStyles implements IAction {
	public config: IActionConfig;
	private _page: DataPage;

	constructor(config: IActionConfig) {
		this.config = config;
		this._page = config.page;
	}

	do() {
		const { cell, grid } = this.config;
		const { row, col } = getCellIds(cell, grid);

		const cellInfo = getCellInfo(cell, this._page, grid);
		if (cellInfo.locked) {
			return;
		}

		this.config.prev = cellInfo.css;

		this._page.setCell(row, col, { css: "" });

		this.config.spreadsheet.events.fire(SpreadsheetEvents.afterStyleChange, [cell, {}]);
		this.config.grid.paint();
	}

	undo() {
		const { cell, grid } = this.config;
		const { row, col } = getCellIds(cell, grid);
		const cellInfo = getCellInfo(cell, this._page, grid);
		if (cellInfo.locked) {
			return;
		}

		this._page.setCell(row, col, { css: this.config.prev });

		this.config.spreadsheet.events.fire(SpreadsheetEvents.afterStyleChange, [cell, {}]);
	}
}
